import React, { useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import LeadsContext from '../../providers/Leads';
import { Button } from 'ncoded-component-library';
import ChevrondownIcon from 'icons/Chevrondown.icon';

import './ShowInactiveLeads.styles.scss';

type ShowInactiveLeadsProps = {
  className?: string;
};

const ShowInactiveLeads: React.FC<ShowInactiveLeadsProps> = (props) => {
  const { className } = props;

  const {
    showInactiveLeads,
    numberOfWaitlistedGridLeads,
    setShowInactiveLeads,
  } = useContext(LeadsContext);

  const classes = classNames(
    'show-inactive-leads',
    { 'show-inactive-leads--open': showInactiveLeads },
    className,
  );

  const { t } = useTranslation();

  if (!numberOfWaitlistedGridLeads) return null;

  return (
    <Button
      className={classes}
      variant="link"
      iconPosition="right"
      icon={ChevrondownIcon}
      onClick={() => setShowInactiveLeads((old) => !old)}
    >
      {t('showInactiveLeads', { count: numberOfWaitlistedGridLeads })}
    </Button>
  );
};

export default ShowInactiveLeads;
